import { ReactNode } from 'react';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  variant?: 'light' | 'dark';
}

export default function GlassCard({
  children,
  className = '',
  variant = 'light',
}: GlassCardProps) {
  const baseStyles =
    variant === 'light'
      ? 'bg-white/80 backdrop-blur-lg rounded-2xl shadow-lg border border-white/20'
      : 'bg-white/10 backdrop-blur-lg rounded-2xl border border-white/10';

  return <div className={`${baseStyles} ${className}`}>{children}</div>;
}
